module.exports = __webpack_public_path__ + "img/tewi inaba_sc2.dd866942.png";